module.exports = __webpack_public_path__ + "assets/2080b2ac5647f76908b8fc8630de90ea.jpg";